import { render, staticRenderFns } from "./ServiceBlock.vue?vue&type=template&id=7c14b166"
import script from "./ServiceBlock.vue?vue&type=script&lang=js"
export * from "./ServiceBlock.vue?vue&type=script&lang=js"
import style0 from "./ServiceBlock.vue?vue&type=style&index=0&id=7c14b166&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports